import { useCallback } from "react";
import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { isDirect } from "../../marketing-url-params";

const utils = createTrackingUtils({
  name: "flights_web_mdot_stop_search_result_timeout",
  defaultStage: 1,
  stages: {
    main: 1,
    direct: 2,
    meta: 3,
    solo: 4,
    nonSolo: 5,
    us: 6
  },
  goals: {}
});

export default function useFlightsWebMdotStopSearchResultTimeout() {
  const { isSolo, isAmerican } = useProfiler();

  const isVariant = useCallback(() => {
    return !!utils.trackWithDefaultStage();
  }, []);

  const trackStages = useCallback(() => {
    utils.stages.main();
    if (isDirect()) utils.stages.direct();
    if (!isDirect()) utils.stages.meta();
    if (isSolo()) utils.stages.solo();
    if (!isSolo()) utils.stages.nonSolo();
    if (isAmerican()) utils.stages.us();
  }, [isSolo, isAmerican]);

  return { isVariant, trackStages };
}
